import React from "react";

// Animated background: subtle particle dots + radial gradients
export default function ParticleBackground({ density = 40 }) {
  const dots = React.useMemo(() => {
    return Array.from({ length: density }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2.5 + 0.6,
      delay: Math.random() * 8,
      duration: 6 + Math.random() * 8,
      opacity: Math.random() * 0.5 + 0.15,
    }));
  }, [density]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* deep gradient backdrop */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(14,165,233,0.18),transparent_60%),radial-gradient(ellipse_at_bottom_right,_rgba(212,175,55,0.10),transparent_55%)]" />
      {/* grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
          maskImage: "radial-gradient(ellipse at center, black 30%, transparent 70%)",
          WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 70%)",
        }}
      />
      {/* particles */}
      {dots.map((d) => (
        <span
          key={d.id}
          className="absolute rounded-full bg-sky-300"
          style={{
            left: `${d.x}%`,
            top: `${d.y}%`,
            width: d.size,
            height: d.size,
            opacity: d.opacity,
            animation: `floaty ${d.duration}s ease-in-out ${d.delay}s infinite`,
            boxShadow: "0 0 8px rgba(125,211,252,0.6)",
          }}
        />
      ))}
    </div>
  );
}
